export const STORE_SETTINGS_PUBLIC_REQUEST = "STORE_SETTINGS_PUBLIC_REQUEST";
export const STORE_SETTINGS_PUBLIC_SUCCESS = "STORE_SETTINGS_PUBLIC_SUCCESS";
export const STORE_SETTINGS_PUBLIC_FAIL = "STORE_SETTINGS_PUBLIC_FAIL";